<!-- <h1 mat-dialog-title style="height: 50px;">{{data.title}}</h1>
<span style="position: absolute;top: 0;right:10px;font-size: x-large;cursor: pointer;" (click)="onCloseClick()"><fa-icon size="xs" icon="window-close" class="center status" ></fa-icon></span>
<div mat-dialog-content style="max-height: 80vh;padding: 0px 2px 1px 2px;">
  <iframe style="height: calc(100vh - 128px);width: 100%;"
    sandbox="allow-forms allow-popups allow-scripts allow-same-origin allow-modals allow-downloads" frameborder="0"
    [src]="data.url"></iframe>

</div> -->

<h1 mat-dialog-title style="height: 50px;">{{data.title}}</h1>
<span style="position: absolute;top: 0;right:10px;font-size: x-large;cursor: pointer;" (click)="onCloseClick()"><fa-icon
    size="xs" icon="window-close" class="center status"></fa-icon></span>

<iframe class="modal_container" style="height: calc(100vh - 74px);width: 100%;"
  sandbox="allow-forms allow-popups allow-scripts allow-same-origin allow-modals allow-downloads" frameborder="0"
  [src]="data.url"></iframe>